import { ToolkitListingID } from '@aloft/toolkit-shared';
import { UseQueryResult, useQueries } from '@tanstack/react-query';

import { useToolkitContext } from '../../../hooks/api/toolkitContext.js';
import { useToolkitControllerGlobal } from '../useToolkitControllerGlobal.js';
import { ListingResult } from './types.js';

export function useGetListings(listingIDs: ToolkitListingID[]): UseQueryResult<ListingResult>[] {
  const { fetcherOptions } = useToolkitContext();
  const { mlsListingsBatcher } = useToolkitControllerGlobal();
  return useQueries({
    queries: listingIDs.map((listingID) => {
      return {
        queryKey: ['C1Listing', listingID],
        queryFn: async () => {
          return mlsListingsBatcher.fetch(listingID, fetcherOptions);
        },
        cacheTime: Infinity,
        staleTime: Infinity,
        refetchOnWindowFocus: false,
      };
    }),
  });
}
